import styles from './ImageCheckbox.module.scss';
import React from "react";
import barchart from "./bar-chart.svg";

export type ImageCheckboxProps = {label: string, onChange:( event: React.ChangeEvent<HTMLInputElement>) => void, checked?: boolean, src?: string, alt? : string};
const ImageCheckbox = ({label, onChange, checked=false, src = barchart, alt = "barchart"} : ImageCheckboxProps) => {

    return <label className={styles.label}>
        <p className={styles.text}>{label}</p>
        <input className={styles.input} type="checkbox" onChange={onChange} checked={checked}/>
        <img alt={alt} className={styles.img} src={src} width={"50%"}/>
    </label>
}

export default ImageCheckbox;